import DashDadosQuantidadeContrato from "./DashDadosQuantidadeContrato";

export default class DashConsumoContratual {
  numeroContratoPortal: string;
  numeroContratoSap: string;
  idSku: number;
  skuNome: string;
  quantidadeProduzida: number;
  quantidadeTotal: number;
  porcentagemProduzida: number;
  porcentagemTempoContrato: number;
  dataInicio: Date;
  dataTermino: Date;
  variacaoMinima: number;
  variacaoMaxima: number;
  referencia: String;

  constructor(
    numeroContratoPortal: string,
    numeroContratoSap: string,
    idSku: number,
    skuNome: string,
    quantidadeProduzida: number,
    quantidadeTotal: number,
    porcentagemProduzida: number,
    porcentagemTempoContrato: number,
    dataInicio: Date,
    dataTermino: Date,
    variacaoMinima: number,
    variacaoMaxima: number,
    referencia: String
  ) {
    this.numeroContratoPortal = numeroContratoPortal;
    this.numeroContratoSap = numeroContratoSap;
    this.idSku = idSku;
    this.skuNome = skuNome;
    this.quantidadeProduzida = quantidadeProduzida;
    this.quantidadeTotal = quantidadeTotal;
    this.porcentagemProduzida = porcentagemProduzida;
    this.porcentagemTempoContrato = porcentagemTempoContrato;
    this.dataInicio = dataInicio;
    this.dataTermino = dataTermino;
    this.variacaoMinima = variacaoMinima;
    this.variacaoMaxima = variacaoMaxima;
    this.referencia = referencia;
  }

  static toJson(estoqueBRF: DashConsumoContratual): string {
    return JSON.stringify(estoqueBRF);
  }

  static fromJson(json: object[]): DashConsumoContratual[] {
    return json.map((item: any) => {
      return new DashConsumoContratual(
        item["numeroContratoPortal"],
        item["numeroContratoSap"],
        item["idSku"],
        item["skuNome"],
        item["quantidadeProduzida"],
        item["quantidadeTotal"],
        item["porcentagemProduzida"],
        item["porcentagemTempoContrato"],
        new Date(item["dataInicio"]),
        new Date(item["dataTermino"]),
        item["variacaoMinima"],
        item["variacaoMaxima"],
        item["referencia"],
      );
    });
  }
}
